module.exports = __webpack_public_path__ + "media/images/athletes/1343-d74f88556e606c72179195d2320da58f.png";